import UtilsUrl from "../utils/UtilsUrl";
import api from "./api";

class ProductPurchaseService {
  createProductPurchase(idUser, idProduct, params) {
    return api.post(
      UtilsUrl.productPurchaseURL() +
        "/createProductPurchase/" +
        idUser +
        "/" +
        idProduct,
      null,
      { params }
    );
  }
  // params: { page, size, dateFrom, dateTo, idWarehouse, brandName, productCode }
  // dateFrom / dateTo format: yyyy-MM-dd'T'HH:mm:ss
  getProductPurchasesSummary(idUser, params = {}) {
    const cleanParams = {};
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null && value !== "") {
        cleanParams[key] = value;
      }
    });
    return api.get(
      UtilsUrl.productPurchaseURL() + "/getProductPurchasesSummary/" + idUser,
      { params: cleanParams }
    );
  }

  // purchaseDate format: yyyy-MM-dd'T'HH:mm:ss, file: .xlsx (barcode, quantity, buying price)
  importProductPurchasesWarehouse(idUser, idWarehouse, purchaseDate, file) {
    const formData = new FormData();
    formData.append("file", file);
    return api.post(
      UtilsUrl.productPurchaseURL() +
        "/importProductPurchasesWarehouse/" +
        idUser +
        "/" +
        idWarehouse +
        "/" +
        purchaseDate,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  }
}

export default new ProductPurchaseService();
